module.exports = __webpack_public_path__ + "static/media/Purchase_Button@3x.f9ad8421.png";